import { navLinks } from "@/mocks/community";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-heart-pulse-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">腐漫网</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              腐女同好社区 · BL 圈子互动平台。找同好、聊剧情、分享心头好，随时参与腐向交流，畅快聊属于我们的话题。
            </p>
          </div>

          <nav className="flex flex-col gap-2" aria-label="页脚导航">
            <h4 className="mb-2 font-heading text-base font-bold text-background-50">快速导航</h4>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-2">
            <h4 className="mb-2 font-heading text-base font-bold text-background-50">联系我们</h4>
            <p className="flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line"></i>
              hi@fumanhua.example
            </p>
            <p className="flex items-center gap-2 text-sm text-background-200">
              <i className="ri-chat-3-line"></i>
              欢迎加入讨论专区交流
            </p>
            <div className="mt-3 flex gap-2">
              {["ri-twitter-x-line", "ri-wechat-line", "ri-qq-line"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="社交媒体链接"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© {new Date().getFullYear()} 腐漫网 · 所有内容仅供同好交流，请理性分享、尊重版权。</p>
          <p className="inline-flex items-center gap-1">
            <i className="ri-heart-3-fill text-primary-500"></i>
            用心守护每一份热爱
          </p>
        </div>
      </div>
    </footer>
  );
}